import axios from 'axios';
import { Enterprise } from '../entity/entity.types';
import { LawFirmPopoverInfos } from './lawFirm.types';

export async function fetchLawFirmEnterprises(
  lawOfficeIdGroup: string,
  full: boolean = false,
): Promise<{
  enterprises: Enterprise[];
  hasMore: boolean;
  pluralityState: number;
}> {
  return (
    await axios.get('/getLawFirmEnterprises', {
      params: {
        lawOfficeId: lawOfficeIdGroup,
        full,
      },
    })
  ).data;
}

export async function fetchLawFirmInfos(
  lawOfficeIdGroup: string,
): Promise<LawFirmPopoverInfos> {
  return (
    await axios.get('/getLawFirmPopover', {
      params: {
        lawOfficeIdGroup,
      },
    })
  ).data;
}
